import React from 'react';

import { StyleSheet, View, Platform } from 'react-native';

import InputNumber from './InputNumber';
import Text from '../text/Text';

const InputNumberSuffixed = ({
	suffix,
	wrapperStyle = {},
	...passThroughProps
}) => (
	<View
		style={{
			flexDirection: 'row',
			width: 150,
			...wrapperStyle,
		}}
	>
		<InputNumber
			style={{ width: 70 }}
			{...passThroughProps}
		/>
		{
			Boolean(suffix) && (
				<Text
					style={[styles.suffixStyle]}
				>
					{ suffix }
				</Text>
			)
		}
	</View>
);

const styles = StyleSheet.create({
	suffixStyle: {
		marginTop: Platform.OS === 'ios' ? 8 : 7,
		marginLeft: 5,
		flex: 1,
	},
});


export default React.memo(InputNumberSuffixed);
